import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, description, canonical }) => (
    <Helmet>
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
    </Helmet>
);

export default SEO;
